var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{ref:"selector",attrs:{"id":_vm.elementId,"attach":_vm.attachId,"readonly":_vm.readonly,"items":_vm.templates,"menuProps":_vm.menuProps,"loading":_vm.loading,"return-object":"","placeholder":'select'},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }